import "../style/entityExtractionFromImage.scss";
import Title from "./common/Title";
import { useEffect, useState } from "react";
import { dataLoader } from "@unbxd-ui/unbxd-react-components";
import utils from "./common/utils";
import utilsOuter from "../common/utils"
import pageRoute from "../routes/pageRoute";
import Cropper from './common/Cropper';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import downArrow from "../common/images/down_arrow.png";
import searchIcon from "../common/images/search_icon.png";
import Xarrow, { useXarrow, Xwrapper } from "react-xarrows";

utils.addRequestConfigs(pageRoute);
export default function EntityExtractionFromImage() {

  // Map for vertical-specific example images
  const verticalImagesMap = {
    Apparel: [
    [ "https://www.lulus.com/images/product/xlarge/4936110_999862.jpg",
      "https://www.lulus.com/images/product/xlarge/5428416_999982.jpg",
      "https://www.lulus.com/images/product/xlarge/5364636_999882.jpg",
      "https://www.lulus.com/images/product/xlarge/5147090_999742.jpg",
      "http://assets.myntassets.com/assets/images/14851960/2021/9/29/336195d1-0f1b-480d-8c0f-50ec86e2ef001632918203472-Levis-Men-Shirts-2851632918202920-6.jpg",
      "http://assets.myntassets.com/assets/images/2256562/2018/2/5/11517823139990-HIGHLANDER-Men-Black--Grey-Slim-Fit-Checked-Casual-Shirt-6531517823139956-5.jpg"
    ],
    [ "http://assets.myntassets.com/assets/images/10673544/2019/9/24/ec7dcc09-7640-4f17-a49d-69ccce54753c1569310358858-The-Indian-Garage-Co-Men-Shirts-8481569310357131-5.jpg",
      "http://assets.myntassets.com/assets/images/14851862/2021/8/31/326325bd-c860-445c-ac36-0a71df225f5c1630410763201-Levis-Men-White-Tartan-Checks-Opaque-Casual-Shirt-3941630410-6.jpg",
      "http://assets.myntassets.com/assets/images/15071110/2021/8/9/aa514555-ced2-4d56-9381-5fcc00172c7d1628500002845Shirts4.jpg",
      "http://assets.myntassets.com/assets/images/14592096/2021/7/27/2deca763-4461-4fc1-9113-1098b68885521627367904579-Calvin-Klein-Jeans-Men-Shirts-7901627367904192-6.jpg",
      "http://assets.myntassets.com/assets/images/8325421/2019/3/8/7c0c0593-f068-40ee-8e8d-939caa37f4c21552043984706-Mast--Harbour-Men-Navy-Blue-Colourblocked-Polo-Collar-T-shir-6.jpg",
      "http://assets.myntassets.com/assets/images/2337637/2018/2/8/11518089132313-Roadster-Men-Black-Solid-Polo-Collar-T-shirt-9911518089132200-5.jpg",
    ]
    ],
    Home: [
      [
        "https://content.valuecityfurniture.com/images/product/burke_gray_manual-reclining-sofa_2068834_765041.jpg",
        'https://img.zcdn.com.au/lf/79/hash/38448/20129986/4/Grey%2BSienna%2BLuxury%2BBed%2BFrame.jpg',
        'https://img.zcdn.com.au/lf/50/hash/38080/20245107/4/.jpg',
        'https://content.valuecityfurniture.com/images/product/posh_dining-room_main_image_803825.jpg',
        'https://img.zcdn.com.au/lf/50/hash/38080/20397169/4/.jpg',
        "https://content.valuecityfurniture.com/images/product/ryland-bedroom_two-tone_5-pc-queen-bedroom_3059723_2047689.jpg",
        "https://content.valuecityfurniture.com/images/product/cordelle_blue_sofa_2127776_779679.jpg",
        'https://img.zcdn.com.au/lf/50/hash/38080/19623827/4/.jpg',
      ],
      [
        'https://img.zcdn.com.au/lf/50/hash/38868/20181434/4/.jpg',
        'https://img.zcdn.com.au/lf/79/hash/38080/20246301/4/200cm%2BEden%2BSolid%2BAmerican%2BOak%2BTV%2BUnit.jpg',
        'https://img.zcdn.com.au/lf/79/hash/37973/19082140/4/White%2BTribeca%2B6%2BDrawer%2BLowboy%2BDresser.jpg',
        'https://img.zcdn.com.au/lf/79/hash/38295/20394668/4/2%2BPiece%2BAlessa%2BRocking%2BChair%2B%2526%2BFootstool%2BSet.jpg',
        'https://content.valuecityfurniture.com/images/product/hanover-youth-bedroom_light-brown_6-pc-twin-bedroom_3064107_2043517.jpg',
        'https://img.zcdn.com.au/lf/50/hash/37569/20389489/4/.jpg',
        'https://img.zcdn.com.au/lf/50/hash/26082/20165862/4/Silver+%26+Peach+Vintage+Look+Celina+Rug.jpg',
        'https://img.zcdn.com.au/lf/79/hash/38295/19481402/4/Bennett%2B5%2BDrawer%2BChest.jpg',

      ]
    ]
  };

  const [inputValue, setInputValue] = useState("");
  const [image, setImage] = useState(verticalImagesMap['Apparel'][ 0 ][ 0 ]);
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [visualData, setVisualData] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [swiper, setSwiper] = useState(null);
  const [hotSpot, setHotSpot] = useState(0);
  const [scaleX, setScaleX] = useState(1);
  const [scaleY, setScaleY] = useState(1);
  const [imageWidth, setImageWidth] = useState();
  const [imageHeight, setImageHeight] = useState();
  const [lastActive, setLastActive] = useState(false);
  const [vertical, setVertical] = useState("Apparel");
  const [verticalClass, setVerticalClass] = useState("close");

  useEffect(() => {
    // On vertical change, reset to the first image of the first list for that vertical
    setImage(verticalImagesMap[vertical][0][0]);
    setSelectedImage(verticalImagesMap[vertical][0][0]);
  }, [vertical]);

  const toggleVerticalDD = () => {
    setVerticalClass(verticalClass === "close" ? "open" : "close");
  };

  const onVerticalChange = (event) => {
    const newVertical = event.target.getAttribute("data-vertical");
    setVertical(newVertical);
    toggleVerticalDD(); // Close the dropdown after selection
  };

  const callApi2 = () => {
    setIsLoading(true);
    // Ensure vertical is lowercase for the API call
    const verticalParam = vertical.toLowerCase();
    const def = dataLoader.getRequestDef({
      requestId: "getImageTags",
      urlParams: {
          vertical: verticalParam,
      },
      params: {
        url: image,
        vertical: verticalParam,
      },
    });

    def.done((response = []) => {
      setIsLoading(false);
      setApiError("");
      setVisualData(response);
    });

    def.catch((error) => {
      setIsLoading(false);
      setVisualData([]);
      setApiError(error);
    });

    return def;
  };

  const validate = (val) => {
    if (val.length === 0) {
      setApiError("Input cannot be empty");
      return false;
    } else if (!/(?:(?:https?|ftp):\/\/|\b(?:[a-z\d]+\.))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))?/.test(val)) {
      setApiError("Please enter a valid Url");
      return false
    } else {
      setApiError("");
      return true;
    }
  }

  function callApi(e) {
    if (validate(e.target.src || inputValue)) {
      if (e.target.src) {
        setSelectedImage(e.target.src);
        setImage(e.target.src);
      } else {
        setSelectedImage(inputValue);
        setImage(inputValue);
      }
    }
  }

  useEffect(() => {
    if (image.length > 0) {
      const api = callApi2();
      api.then((res = []) => {
        // setData(res)
        const image = document.getElementById('imageExtraction');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        setScaleX(scaleX);
        setScaleY(scaleY);
        setImageWidth(image.width);
        setImageHeight(image.height);
      });
    }
  }, [ image ]);



  const tagsUI = (tagValues) => {
    return tagValues.map((value) => {
      return (
        Object.keys(value)[ 0 ]
      )
    })
  }

  const onHotSpotClick = (index) => {
    setHotSpot(index);
    swiper &&  swiper.slideTo(index)
  };

  return (
    // <div className="section">
    <div className="columns highlight-info floating-hexagon">
       {!isLoading && visualData.map((main = {}, index) => {
                        if (index === hotSpot) {
                            return (
                                <Xwrapper><Xarrow
                                    start={`img-hotspot-${hotSpot}`} //can be react ref
                                    end={`swiper-container`} //or an id
                                    zIndex={1000}
                                    endAnchor={{ position: "left", offset: { x: 150 } }}
                                    dashness={{ strokeLen: 10, nonStrokeLen: 10, animation: -2 }}
                                    animateDrawing={true}
                                /></Xwrapper>
                            )
                        }

                    })}
      <div className="column col-xl-12 col-6 highlight-content-left ">
        <div className="content-wrap">
          <Title className="title mb-2" title="Image Based Document Enrichment" />
          <div className="feature-description desc col-xl-12 col-12">
            Experience Visual AI that powers UNBXD by extracting products
            attributes, curating looks and enriching your catalogue for better
            search results.
          </div>
          <div className="spin">Try Your Image</div>
          <div className="select-vertical mb-1">Select the vertical<span className="mandatory">*</span></div>
          <div className="vertical-dd-container">
            <div className="vertical-dd" onClick={toggleVerticalDD}>
              <span className="vertical-dd-label">{vertical}</span>
              <img className="down-arrow-img" src={downArrow} alt="Toggle Dropdown" />
            </div>
            <ul className={`vertical-dd-list ${verticalClass}`}>
              {Object.keys(verticalImagesMap).map((v) => (
                <li key={v} className="vertical-dd-list-item" data-vertical={v} onClick={onVerticalChange}>
                  {v.charAt(0).toUpperCase() + v.slice(1)} {/* Capitalize the first letter */}
                </li>
              ))}
            </ul>
          </div>

          <div className="search-container">
            <div className="search-input-container">
              <input type="text" value={inputValue} className="search-input" placeholder="Enter Image URL" onChange={e => setInputValue(e.target.value)} />
              <img src={searchIcon} className="search-img" />
            </div>
            <button onClick={e => callApi(e)} className="search-button">Preview</button>
          </div>
          {apiError && <div className="api-error entity-extraction">{apiError}</div>}

          <div className="image-container">
            <div className="spin">Try With Sample Images</div>
            <div className="box">
              {verticalImagesMap[vertical].map((arrItem) => {
                return <div className="box-items">
                  {arrItem.map(item => {
                    return <img
                      className={`product-img ${selectedImage === item ? "product-img-selected" : ""}`}
                      src={(item)}
                      onClick={(e) => callApi(e)}
                    />;
                  })}
                </div>
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="column col-xl-12 col-6">
        <div className="content-wrap">

          {!apiError  && <div className="top">
            <div className="image-extr" style={{ width: imageWidth, height: imageHeight,  margin: '0 auto'}} >
              <img id="imageExtraction" className="right-product-img" src={image} />
              { !isLoading&& visualData.map((main = {}, index) => {
                // const image = document.getElementById('imageExtraction');
                // const scaleX = image.naturalWidth / image.width;
                // const scaleY = image.naturalHeight / image.height;

                const coordinates = main.box;
                const x = coordinates[ 0 ],
                  y = coordinates[ 1 ],
                  width = coordinates[ 2 ] - coordinates[ 0 ],
                  height = coordinates[ 3 ] - coordinates[ 1 ];
                const left = (x + width / 2) / scaleX - 10;
                const top = (y + height / 2) / scaleY - 10;
                return <div className="hotspot" id={`img-hotspot-${index}`} style={{ top: top, left: left }} onClick={(e) => onHotSpotClick(index)}></div>
              })}
            </div>
          </div>}
          {!apiError && !isLoading && <div className="entity-image-swiper-container">
            <Swiper
            id="swiper-container"
              onSwiper={setSwiper}
              className={lastActive ? "entity-active" : ""}
              modules={[ Navigation, Pagination, Scrollbar, A11y ]}
              spaceBetween={30}
              slidesPerView={"auto"}
              navigation
              // pagination={{ clickable: true }}
              // scrollbar={{ draggable: true }}
              // onSwiper={}
              onSlideChange={(swiper) => {
                const { activeIndex } = swiper;
                setHotSpot(activeIndex)
                if (activeIndex === visualData.length - 1) {
                  setLastActive(true);
                } else {
                  setLastActive(false);
                }
              }}
            >

              {
                visualData.map((arrItem, index) => {
                  const { class: name, tags = {}, box = [] } = arrItem;
                  return (
                    <SwiperSlide>
                      <div className="entity-swiper-container">
                      <Cropper url={image} coordinates={box} key={Math.random()} id={Math.random()} />
                        <div key={name} className="entity-image-results-container">
                          <div className="entity-image-results-header" title={name} >{utilsOuter.capitalize(name.toLowerCase())}</div>
                          <div className="entity-image-results-data">
                            {
                              Object.keys(tags).map((tag) => {
                                const tagValues = tags[ tag ];
                                return (
                                  <div className="entity-image-data columns text-center">
                                    <div className="column col">
                                      {tag}
                                    </div>
                                    <div className="column col text-left">
                                      {tagsUI(tagValues).join(" , ")}
                                    </div>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                       
                      </div>
                    </SwiperSlide>
                  )
                })
              }
            </Swiper>
          </div>}
          {isLoading && <img className="ms-loading-icon" src={"/images/blueLoader.svg"} /> }
        </div>
      </div>
    </div>

  );
}
